<template>
  <div class="bg" style="width: 100%;height: 100%;min-height: 100vh;">
    <MyNavBar v-show="!isApp" back style="position: fixed;top: 0;left: 0;right: 0" title="我的打卡"
              @onBackClick="onBack"/>
    <!--    <van-pull-refresh :v-model="isLoading">-->
    <!-- 顶部：本周打卡进度 -->
    <div v-show="!isApp" style="height: 44px"></div>
    <div>
      <div>
        <my-img url="https://cdn.keihong.tech/img/202408191154870.png"/>
      </div>
      <div style="width: 100%;padding: 16px;box-sizing: border-box;margin-top: -32px;z-index: 100;position:relative;">
        <div
          style="background-color: #12B96A;border-radius: 100px;text-align: center;font-size: 18px;font-weight: bold;color: white;padding: 8px">
          坚持每天训练打卡，早日康复！
        </div>
      </div>
      <div v-if="isLoading" style="text-align: center">
        <!--  loading  -->
        <van-loading color="#1989fa" size="48px" style="margin-top: 32px;" type="spinner"/>
        <div>加载数据中</div>
      </div>
      <div v-else>

        <!-- 本周打卡作业 - 新UI设计 -->
        <div class="weekly-tasks-card">
          <div class="tasks-header">
            <div class="tasks-icon">
              <van-icon name="records" size="24" color="#12B96A" />
            </div>
            <div class="tasks-title">
              <div class="main-title">本周康复作业</div>
              <div class="sub-title">{{ todayTasks.title }}</div>
            </div>
          </div>

          <div class="tasks-content">
            <div class="task-list">
              <div
                v-for="(detail, index) in todayTasks.details"
                :key="index"
                class="task-item"
              >
                <div class="task-number">{{ index + 1 }}</div>
                <div class="task-text">{{ detail }}</div>
                <div class="task-status">
                  <van-icon name="clock-o" size="14" color="#999" />
                </div>
              </div>
            </div>
          </div>

                              <div class="tasks-footer">
            <van-button
              type="primary"
              size="small"
              round
              color="#12B96A"
              disabled
            >
              打开 AI 康复训练仪 进行 AI 跟练吧～
            </van-button>
          </div>
        </div>

        <!--    打卡记录    -->
        <div style="background-color: white;margin: 0 16px;border: #d1d1d1 0.5px solid;border-radius: 8px 8px 0 0">
          <div style="text-align: center;font-weight: bold;font-size: 20px">AI 训练仪训练记录</div>
        </div>
        <div v-if="!dakaRecord">
          加载记录中...
        </div>
        <div>
          <div v-for="(record) in dakaRecord" :key="record.id"
               class="game-record-card">
            <!-- 顶部：日期时间 -->
            <div class="game-record-card__date">
              {{ getRecordDateTime(record) }}
            </div>
            <!-- 主体数据区块 -->
            <div class="game-record-card__main">
              <div class="game-record-card__item">
                <van-icon name="clock-o" size="28" color="#12B96A" />
                <div class="game-record-card__num">{{ getRecordDuration(record) }}</div>
                <div class="game-record-card__label">训练时长</div>
              </div>
              <div class="game-record-card__item">
                <van-icon name="fire" size="28" color="#ff6200" />
                <div class="game-record-card__num">{{ getRecordCompletedCourses(record) }}</div>
                <div class="game-record-card__label">完成动作</div>
              </div>
              <div class="game-record-card__item">
                <van-icon name="checked" size="28" color="#4caf50" />

                <div class="game-record-card__num">{{ getRecordArmCount(record) }}</div>
                <div class="game-record-card__label">手臂运动</div>
              </div>
              <div class="game-record-card__item">
                <van-icon name="checked" size="28" color="#4caf50" />
                <div class="game-record-card__num">{{ getRecordLegCount(record) }}</div>
                <div class="game-record-card__label">腿部运动</div>
              </div>
            </div>
            <!-- 星级和评价 -->
            <div class="game-record-card__stars">
              <span v-for="n in getRecordRating(record)" :key="n">
                <van-icon name="star" color="#FFD700" size="24" />
              </span>
              <span v-for="n in (5-getRecordRating(record))" :key="'empty'+n">
                <van-icon name="star-o" color="#FFD700" size="24" />
              </span>
            </div>
            <div class="game-record-card__rating-text">
              {{ getRecordRatingText(record) }}
            </div>
            <div class="game-record-card__encourage">
              {{ getRecordEncouragementText(record) }}
            </div>
                        <!-- 分享按钮 -->
            <div class="game-record-card__share">
              <van-button
                type="primary"
                size="small"
                round
                color="#12B96A"
                @click="shareRecord(record)"
              >
                <van-icon name="share-o" size="14" />
                分享打卡
              </van-button>
            </div>
          </div>
        </div>
        <div style="height: 48px"></div>
        <!--    </van-pull-refresh>-->
      </div>
    </div>
    <van-popup v-model="showVideoPopup" :style="{ height: '60%' }" position="bottom" @close="closePop">
      <!--      <van-video :src="videoUrl" :poster="posterUrl" :autoplay="true" :show-center-play="false" :close-on-click-overlay="true" />-->
      <video
        v-if="currentVideo"
        ref="video"
        :src="currentVideo"
        autoplay="autoplay"
        class="play-video"
        controls="controls"
      >
      </video>
      <!--   按钮   -->
      <div style="text-align: center;padding: 16px">
        <van-button style="width: 100%" type="primary" @click="closePop">关闭</van-button>
      </div>
    </van-popup>
    <van-popup v-model="showUploadLoading"
               :close-on-click-overlay="false"
               style="height: 30%;width: 100%;box-sizing:border-box;padding: 32px;background: transparent">
      <div
        style="position: relative;width: 100%;height: 100%;background: white;border-radius: 32px;text-align: center;padding: 32px;box-sizing: border-box">
        <div style="font-size: 18px">上传进度</div>
        <div style="font-size: 32px;font-weight: bold">{{ currentUploadPercent }}%</div>
        <div v-if="uploadFinish"
             style="font-size: 18px;background-color: #ff6200;color: white;padding: 16px;position: absolute;bottom: 0;left: 0;right: 0;border-bottom-left-radius: 32px;border-bottom-right-radius: 32px"
             @click="onUploadClose">
          完成并关闭
        </div>
      </div>
    </van-popup>
    <!-- 分享预览弹窗 -->
    <van-popup
      v-model="showSharePreview"
      :style="{ width: '90%', height: '80%' }"
      position="center"
      round
      @close="closeSharePreview"
    >
      <div class="share-preview-container">
        <!-- 预览标题 -->
        <div class="share-preview-header">
          <div class="share-preview-title">分享预览</div>
          <van-icon name="cross" size="20" @click="closeSharePreview" />
        </div>

        <!-- 图片预览区域 -->
        <div class="share-preview-content">
          <div v-if="isGeneratingImage" class="share-preview-loading">
            <van-loading color="#12B96A" size="48px" type="spinner" />
            <div class="loading-text">生成分享图片中...</div>
          </div>
          <div v-else-if="shareImageUrl" class="share-preview-image" :class="{ 'long-pressing': isLongPressing }">
            <img
              :src="shareImageUrl"
              alt="分享图片"
              @touchstart="startLongPress"
              @touchend="endLongPress"
              @touchcancel="endLongPress"
            />
            <!-- 长按进度提示 -->
            <div v-if="isLongPressing" class="long-press-progress">
              <div class="progress-circle">
                <van-loading color="#12B96A" size="24px" type="spinner" />
              </div>
              <div class="progress-text">长按保存中...</div>
            </div>
            <div class="share-preview-tip">
              <van-icon name="info-o" size="16" color="#12B96A" />
              <span>长按图片保存到相册</span>
            </div>
          </div>
        </div>

        <!-- 操作按钮 -->
        <!--
        <div class="share-preview-actions">
          <van-button
            v-if="shareImageUrl"
            type="primary"
            size="large"
            color="#12B96A"
            @click="saveShareImage"
          >
            <van-icon name="down" size="16" />
            保存到相册
          </van-button>
          <van-button
            plain
            size="large"
            @click="closeSharePreview"
          >
            取消
          </van-button>
        </div>
        -->
      </div>
    </van-popup>
  </div>
</template>
<script>

import MyNavBar from '@/h5/doucan/components/MyNavBar.vue'
import PlanDao from '@/h5/doucan/network/PlanDao'
import DakaDao from '@/h5/doucan/network/DakaDao'
import DateUtils from '@/utils/DateUtils'
import MyImg from '@/h5/doucan/components/MyImg.vue'

export default {
  name: 'PatientDataHomePage',
  components: {
    MyImg,
    MyNavBar
  },
  data () {
    return {
      // isTest: true,
      isApp: false,
      userId: null,
      phone: null,
      videoSelect: [],
      functionItems: [
        {
          url: 'https://cdn.keihong.tech/img/202312122245163.png',
          name: '信息录入'
        },
        {
          url: 'https://cdn.keihong.tech/img/202312122246398.png',
          name: '录入记录'
        }
      ],
      isLoading: true,
      completedDays: -1,
      totalDays: -1,
      weekDays: [],
      plan: null,
      plans: [],
      todayTasks: {
        title: '学习内容',
        details: ['上肢训练', '下肢训练', '头部训练']
      },
      dakaRecord: null,
      showVideoPopup: false,
      showUploadLoading: false,
      currentVideo: null,
      currentUploadPercent: 0,
      uploadFinish: false,
      todayFinish: false,
      // 分享预览相关
      showSharePreview: false,
      shareImageUrl: null,
      isGeneratingImage: false,
      // 长按相关
      isLongPressing: false,
      longPressTimer: null
    }
  },
  async mounted () {
    this.isApp = this.$route.query.isApp
    const from = this.$route.query.from
    if (from === 'wxapp') {
      this.isApp = true
      this.userId = this.$route.query.userId
      this.phone = this.$route.query.phone
    } else if (this.isApp) {
      this.userId = this.$route.query.userId
      this.phone = this.$route.query.phone
    } else {
      this.userId = this.$store.state.user.profile.userId
      this.phone = this.$store.state.user.profile.phone
    }

    console.log('user id', this.userId)
    if (this.userId) {
      await this.loadPlan()
      await this.loadDaka()
      this.isLoading = false
    }
  },
  beforeDestroy () {
    // 清理定时器
    if (this.longPressTimer) {
      clearTimeout(this.longPressTimer)
      this.longPressTimer = null
    }
  },
  methods: {
    onBack () {
      if (this.$store.state.user.qrCodeHospital === '宏乾健康') {
        this.$router.push('/hongqian/home')
      } else {
        this.$router.back()
      }
    },
    onUploadClose () {
      this.showUploadLoading = false
      // 刷新
      this.$router.go(0)
    },
    handleRecordClick (record) {
      // AI训练记录没有视频，显示详细信息
      if (record.type === 2) {
        this.$toast('AI训练记录详情功能开发中...')
        return
      }

      // 普通打卡记录有视频
      if (record.videoUrl) {
        this.showVideoPopup = true
        this.currentVideo = record.videoUrl
      } else {
        this.$toast('该记录暂无视频')
      }
    },
    handleDayClick (day) {
      console.log('day', day)
      if (day.status === 'completed') {
        this.showVideoPopup = true
        this.currentVideo = day.newestVideoUrl
      } else {
        this.$toast('该日期未打卡')
      }
    },
    async closePop () {
      this.showVideoPopup = false
      this.$refs.video.pause()
    },
    async loadPlan () {
      const datas = await PlanDao.loadList(this.phone)

      if (datas && datas.length >= 1) {
        this.plans = datas
        this.plan = datas[0].plan
        this.plan = JSON.parse(this.plan)
        // this.gmtCreate = DateUtils.formate(this.gmtCreate, 'yyyy-MM-dd')
        console.log('方案', this.plan)
        this.todayTasks.title = this.plan.planTitle
        this.todayTasks.details = this.plan.planCourseBeans.map(course => course.courseName)
      } else {
        this.todayTasks.title = '您暂未有个性化训练方案，请联系医生或康复助理'
        this.todayTasks.details = ['无']
      }
    },
    async loadDaka () {
      this.dakaRecord = await DakaDao.load(this.userId)

      // 根据type字段过滤记录：1是打卡，2是AI训练，本页面只显示AI训练记录
      if (this.dakaRecord && this.dakaRecord.length > 0) {
        // 过滤出AI训练记录（type=2）
        this.dakaRecord = this.dakaRecord.filter(item => item.type === 2)

        // 解析aiPadRecordJson并格式化dakaRecord中每个item的gmtCreate字段
        this.dakaRecord.forEach(item => {
          item.gmtCreate = DateUtils.formattedTime(item.gmtCreate)
          // 解析aiPadRecordJson
          if (item.aiPadRecordJson) {
            try {
              item.parsedRecord = JSON.parse(item.aiPadRecordJson)
            } catch (error) {
              console.error('解析aiPadRecordJson失败:', error)
              item.parsedRecord = null
            }
          }
        })
      }
      console.log('AI训练记录', this.dakaRecord)
      this.getWeekStatus()
      this.getTotalDays()
    },
    getWeekStatus () {
      // 筛选本周数据
      const thisWeekRecords = this.dakaRecord.filter(record => this.isDateInThisWeek(record.gmtCreate))

      // 按日期分组并排序
      const recordsGroupedByDay = thisWeekRecords.reduce((acc, record) => {
        var date = DateUtils.formate(new Date(record.gmtCreate).getTime(), 'yyyy-MM-DD') // 获取日期部分，忽略时间
        if (!acc[date]) {
          acc[date] = []
        }
        acc[date].push(record)
        // 确保每天的记录按时间倒序排列
        acc[date].sort((a, b) => b.gmtCreate - a.gmtCreate)
        return acc
      }, {})

      console.log('本周打卡数据', recordsGroupedByDay)
      this.completedDays = Object.keys(recordsGroupedByDay).length

      this.weekDays = this.processWeekdata(recordsGroupedByDay)
      console.log('本周打卡统计', this.weekDays)

      // 今天打卡了没 todayFinish
      this.todayFinish = this.weekDays.some(day => {
        if (day.dateStr === DateUtils.formateDate(new Date(), 'yyyy-MM-DD')) {
          if (day.status === 'completed') {
            return true
          } else {
            return false
          }
        }
      })
    },
    getTotalDays () {
      // 筛选本周数据

      // 按日期分组并排序
      const recordsGroupedByDay = this.dakaRecord.reduce((acc, record) => {
        var date = DateUtils.formateDate(new Date(record.gmtCreate), 'yyyy-MM-DD') // 获取日期部分，忽略时间
        if (!acc[date]) {
          acc[date] = []
        }
        acc[date].push(record)
        // 确保每天的记录按时间倒序排列
        acc[date].sort((a, b) => b.gmtCreate - a.gmtCreate)
        return acc
      }, {})

      console.log('全部打卡数据', recordsGroupedByDay)
      this.totalDays = Object.keys(recordsGroupedByDay).length
    },
    getBackgroundColor (status) {
      switch (status) {
        case 'completed':
          return 'rgb(0,183,79)'
        case 'missed':
          return 'grey'
        case 'pending':
          return 'rgba(19,107,89,0.35)'
        default:
          return 'transparent'
      }
    },
    // 上传视频
    async afterRead (file) {
      this.uploadFinish = false
      this.showUploadLoading = true
      console.log('afterRead', file)
      const result = await this.uploadToAliyun(file.file, 0)
      const videourl = result.res.requestUrls[0].substring(0, result.res.requestUrls[0].indexOf('?'))
      console.log('【视频URL】', videourl)
      await DakaDao.add(this.userId, videourl)
      this.videoSelect = []
      this.uploadFinish = true
    },
    async uploadToAliyun (file, index) {
      this.currentUploadImageIndex = index
      const _that = this
      const OSS = require('ali-oss')
      const ossConfig = {
        // region以杭州为例（oss-cn-hangzhou），其他region按实际情况填写。
        region: 'oss-cn-shenzhen',
        // 阿里云主账号AccessKey拥有所有API的访问权限，风险很高。强烈建议您创建并使用RAM账号进行API访问或日常运维，请登录RAM控制台创建RAM账号。
        accessKeyId: 'LTAIAcClE56I1mY0',
        accessKeySecret: 'IIPoiW0o3noCHU9bRT5vyAw0EDtem8',
        bucket: 'ihealthy'
      }
      const client = new OSS(ossConfig)
      // console.log(file)
      // 分片上传文件
      const s = 'daka_video/' + file.name
      console.log('上传文件', s)
      const ret = await client.multipartUpload(s, file, {
        progress: async function (p) {
          // console.log('multipartUpload', p)
          const e = {}
          e.percent = parseInt(p * 100)
          console.log(`上传进度:  第${index + 1}张图片 - ${e.percent} - `)

          _that.currentUploadPercent = e.percent
          // option.onProgress(e)
        }
      })
      console.log('上传结果', ret)
      if (ret.res.statusCode === 200) {
        // option.onSuccess(ret)
        console.log('上传成功', ret)
        return ret
      } else {
        // vm.disabled = false
        // option.onError('上传失败')
        console.log('上传失败', ret)
        return null
      }
    },
    handlePlanClick () {
      this.$router.push('/plangymnasticsSel')
    },
    // 获取本周开始日期（周一）和结束日期（周日）
    getWeekRange () {
      const now = new Date()
      const dayOfWeek = now.getDay() === 0 ? 7 : now.getDay() // 获取当前日期是一周中的第几天，0表示周日，1表示周一，以此类推
      const date = now.getDate() // 获取当前的日，如今天是6月9日，则date=9
      console.log('dayOfWeek', dayOfWeek)
      console.log('date', date)
      const startDate = new Date(now)
      startDate.setDate(date - dayOfWeek + 1) // 如果是周日，则保持不变，否则向前推到周一
      startDate.setHours(0, 0, 0, 0) // 设置时间为00:00:00

      const endDate = new Date(startDate)
      endDate.setDate(endDate.getDate() + 6) // 增加6天到达周日
      endDate.setHours(23, 59, 59, 999) // 设置时间为23:59:59.999，接近但不等于下周一的00:00:00

      return {
        startDate,
        endDate
      }
    },
    // 判断给定日期是否在本周内
    isDateInThisWeek (dateString) {
      var date = new Date(dateString)
      var {
        startDate,
        endDate
      } = this.getWeekRange()
      // date = DateUtils.formate(date.getMilliseconds(), 'yyyy-MM-dd HH:mm')
      // startDate = DateUtils.formate(startDate.getMilliseconds(), 'yyyy-MM-dd HH:mm')
      // endDate = DateUtils.formate(endDate.getMilliseconds(), 'yyyy-MM-dd HH:mm')
      console.log('【日期】', date, '【开始日期】', startDate, '【结束日期】', endDate)
      return date >= startDate && date <= endDate
    },
    processWeekdata (data) {
      const weekDays = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
      const result = []
      const today = new Date()
      const dayOfWeek = today.getDay() // 获取今天是周几 (0 是周日)
      const mondayIndex = dayOfWeek === 0 ? 6 : dayOfWeek - 1 // 获取周一的索引，如果今天是周日(dayOfWeek === 0)，则昨天是周六(index 6)

      // 生成本周一至周日的日期
      const datesOfWeek = weekDays.map((_, index) => {
        const date = new Date(today)
        date.setDate(today.getDate() - mondayIndex + index)
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
      })

      // 处理每一天的数据
      datesOfWeek.forEach((date, index) => {
        const records = data[date]
        let status = 'pending'
        let newestVideoUrl = ''

        if (records && records.length > 0) {
          // 存在记录，找到最新的视频URL
          const sortedRecords = records.sort((a, b) => new Date(b.gmtCreate) - new Date(a.gmtCreate))
          newestVideoUrl = sortedRecords[0].videoUrl
          status = 'completed'
        } else if (new Date(date) < today) {
          // 日期已过且没有记录
          status = 'missed'
        }

        result.push({
          dateStr: date,
          date: weekDays[index],
          status: status,
          newestVideoUrl: newestVideoUrl
        })
      })

      return result
    },

    // 获取记录标题
    getRecordTitle (record) {
      if (record.parsedRecord && record.parsedRecord.training) {
        return record.parsedRecord.training.planTitle || '未知训练方案'
      }
      return '未知训练方案'
    },

    // 获取记录状态
    getRecordStatus (record) {
      if (record.parsedRecord && record.parsedRecord.training) {
        return record.parsedRecord.training.isCompleted ? '已完成' : '未完成'
      }
      return '未知'
    },

    // 获取训练时长
    getRecordDuration (record) {
      if (record.parsedRecord && record.parsedRecord.training) {
        return record.parsedRecord.training.formattedDuration || '0:00'
      }
      return '0:00'
    },

    // 获取完成率
    getRecordCompletionRate (record) {
      if (record.parsedRecord && record.parsedRecord.courseCompletion) {
        return record.parsedRecord.courseCompletion.completionRate || 0
      }
      return 0
    },

    // 获取动作数
    getRecordMovements (record) {
      if (record.parsedRecord && record.parsedRecord.movements) {
        return record.parsedRecord.movements.totalMovements || 0
      }
      return 0
    },
    // 获取完成动作数
    getRecordCompletedCourses (record) {
      if (record.parsedRecord && record.parsedRecord.courseCompletion) {
        return record.parsedRecord.courseCompletion.completedCourses || 0
      }
      return 0
    },
    // 获取总动作数
    getRecordTotalCourses (record) {
      if (record.parsedRecord && record.parsedRecord.courseCompletion) {
        return record.parsedRecord.courseCompletion.totalCourses || 0
      }
      return 0
    },
    // 获取手臂运动次数
    getRecordArmCount (record) {
      if (record.parsedRecord && record.parsedRecord.movements) {
        return record.parsedRecord.movements.armCount || 0
      }
      return 0
    },
    // 获取腿部运动次数
    getRecordLegCount (record) {
      if (record.parsedRecord && record.parsedRecord.movements) {
        return record.parsedRecord.movements.legCount || 0
      }
      return 0
    },
    // 获取星级
    getRecordRating (record) {
      if (record.parsedRecord && record.parsedRecord.evaluation) {
        return record.parsedRecord.evaluation.rating || 0
      }
      return 0
    },
    // 获取评价文字
    getRecordRatingText (record) {
      if (record.parsedRecord && record.parsedRecord.evaluation) {
        return record.parsedRecord.evaluation.ratingText || ''
      }
      return ''
    },
    // 获取鼓励语
    getRecordEncouragementText (record) {
      if (record.parsedRecord && record.parsedRecord.evaluation) {
        return record.parsedRecord.evaluation.encouragementText || ''
      }
      return ''
    },
    // 获取日期时间字符串
    getRecordDateTime (record) {
      // record.gmtCreate 已经格式化为 yyyy-MM-dd HH:mm
      return record.gmtCreate || ''
    },
    /**
     * 分享训练记录
     * 生成4:3垂直比例的分享图片并显示预览
     * @param {Object} record - 训练记录对象
     */
    async shareRecord (record) {
      try {
        // 显示预览弹窗并开始生成图片
        this.showSharePreview = true
        this.isGeneratingImage = true
        this.shareImageUrl = null

        const shareImage = await this.generateShareImage(record)
        if (shareImage) {
          this.shareImageUrl = shareImage
        } else {
          this.$toast.fail('分享图片生成失败')
          this.closeSharePreview()
        }
      } catch (error) {
        console.error('分享失败:', error)
        this.$toast.fail('分享失败，请重试')
        this.closeSharePreview()
      }
    },
    async saveImageToAlbum (imageDataUrl) {
      return new Promise((resolve, reject) => {
        try {
          // 检查是否在移动端环境
          const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

          if (isMobile && window.wx) {
            // 微信小程序环境
            this.saveToWechatAlbum(imageDataUrl, resolve, reject)
          } else if (isMobile && window.cordova) {
            // Cordova环境
            this.saveToCordovaAlbum(imageDataUrl, resolve, reject)
          } else {
            // 普通浏览器环境，使用下载方式
            this.downloadImage(imageDataUrl, resolve, reject)
          }
        } catch (error) {
          // 降级到下载方式
          this.downloadImage(imageDataUrl, resolve, reject)
        }
      })
    },
    downloadImage (imageDataUrl, resolve, reject) {
      try {
        // 创建临时链接
        const link = document.createElement('a')
        link.download = `AI康复训练打卡_${new Date().getTime()}.png`
        link.href = imageDataUrl

        // 触发下载
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        resolve()
      } catch (error) {
        reject(error)
      }
    },
    saveToWechatAlbum (imageDataUrl, resolve, reject) {
      // 微信小程序保存图片到相册
      if (window.wx && window.wx.saveImageToPhotosAlbum) {
        // 需要先将base64转换为临时文件路径
        // 这里简化处理，实际项目中需要调用微信API
        this.downloadImage(imageDataUrl, resolve, reject)
      } else {
        this.downloadImage(imageDataUrl, resolve, reject)
      }
    },
    saveToCordovaAlbum (imageDataUrl, resolve, reject) {
      // Cordova环境保存图片到相册
      if (window.cordova && window.cordova.plugins && window.cordova.plugins.photoLibrary) {
        // 使用Cordova插件保存图片
        window.cordova.plugins.photoLibrary.saveImage(imageDataUrl, 'AI康复训练打卡', resolve, reject)
      } else {
        this.downloadImage(imageDataUrl, resolve, reject)
      }
    },
    /**
     * 在背景图片的指定区域绘制训练数据
     * @param {CanvasRenderingContext2D} ctx - 画布上下文
     * @param {Object} record - 训练记录
     * @param {Object} contentArea - 内容区域 {x, y, width, height}
     */
    drawTrainingDataOnBackground (ctx, record, contentArea) {
      const { x: startX, y: startY, width: contentWidth, height: contentHeight } = contentArea

      // 重置阴影和样式
      ctx.shadowColor = 'transparent'
      ctx.shadowBlur = 0

      // 格式化日期时间为 年月日 hh:mm 格式
      const formatDateTime = (dateTimeStr) => {
        const date = new Date(dateTimeStr)
        const year = date.getFullYear()
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${year}年${month}月${day}日 ${hours}:${minutes}`
      }

      const centerX = startX + contentWidth / 2

      // 绘制"完成时间"小标题 - 增大字体
      ctx.fillStyle = '#666'
      ctx.font = '30px PingFang SC, Microsoft YaHei, Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'top'
      ctx.fillText('完成时间', centerX, startY + 20)

      // 绘制日期时间 - 更大字体
      ctx.fillStyle = '#12B96A'
      ctx.font = 'bold 52px PingFang SC, Microsoft YaHei, Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'top'
      const formattedDateTime = formatDateTime(this.getRecordDateTime(record))
      ctx.fillText(formattedDateTime, centerX, startY + 65)

      // 绘制训练数据卡片背景区域 - 充分利用剩余空间
      const cardStartY = startY + 140
      const cardWidth = contentWidth - 40
      const cardHeight = contentHeight - 160 // 利用剩余空间
      const cardX = startX + 20
      const borderRadius = 25

      // 绘制圆角背景
      ctx.fillStyle = 'rgba(255, 255, 255, 0.98)'
      this.drawRoundedRect(ctx, cardX, cardStartY, cardWidth, cardHeight, borderRadius)
      ctx.fill()

      // 绘制优雅的边框
      ctx.strokeStyle = 'rgba(18, 185, 106, 0.3)'
      ctx.lineWidth = 4
      this.drawRoundedRect(ctx, cardX, cardStartY, cardWidth, cardHeight, borderRadius)
      ctx.stroke()

      // 绘制4个数据项（2x2布局）- 充分利用卡片空间
      const itemWidth = cardWidth / 2
      const itemHeight = cardHeight / 2

      // 数据项配置
      const dataItems = [
        {
          icon: '⏱',
          iconColor: '#12B96A',
          label: '训练时长',
          value: this.getRecordDuration(record),
          x: cardX,
          y: cardStartY
        },
        {
          icon: '🎯',
          iconColor: '#FF6200',
          label: '完成动作',
          value: this.getRecordCompletedCourses(record) + '个',
          x: cardX + itemWidth,
          y: cardStartY
        },
        {
          icon: '💪',
          iconColor: '#4CAF50',
          label: '手臂运动',
          value: this.getRecordArmCount(record) + '次',
          x: cardX,
          y: cardStartY + itemHeight
        },
        {
          icon: '🦵',
          iconColor: '#4CAF50',
          label: '腿部运动',
          value: this.getRecordLegCount(record) + '次',
          x: cardX + itemWidth,
          y: cardStartY + itemHeight
        }
      ]

      // 绘制每个数据项
      dataItems.forEach((item, index) => {
        this.drawLargeDataItem(ctx, item, itemWidth, itemHeight)

        // 绘制简约分隔线
        if (index < dataItems.length - 1) {
          ctx.strokeStyle = 'rgba(18, 185, 106, 0.15)'
          ctx.lineWidth = 2
          if (index === 0) { // 右边竖线
            ctx.beginPath()
            ctx.moveTo(item.x + itemWidth, item.y + 30)
            ctx.lineTo(item.x + itemWidth, item.y + itemHeight - 30)
            ctx.stroke()
          }
          if (index === 1) { // 下面横线
            ctx.beginPath()
            ctx.moveTo(cardX + 30, item.y + itemHeight)
            ctx.lineTo(cardX + cardWidth - 30, item.y + itemHeight)
            ctx.stroke()
          }
        }
      })
    },
    /**
     * 绘制圆角矩形
     */
    drawRoundedRect (ctx, x, y, width, height, radius) {
      ctx.beginPath()
      ctx.moveTo(x + radius, y)
      ctx.lineTo(x + width - radius, y)
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius)
      ctx.lineTo(x + width, y + height - radius)
      ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height)
      ctx.lineTo(x + radius, y + height)
      ctx.quadraticCurveTo(x, y + height, x, y + height - radius)
      ctx.lineTo(x, y + radius)
      ctx.quadraticCurveTo(x, y, x + radius, y)
      ctx.closePath()
    },
    /**
     * 绘制大号数据项 - 充分利用空间
     */
    drawLargeDataItem (ctx, item, width, height) {
      const centerX = item.x + width / 2
      const centerY = item.y + height / 2

      // 绘制图标 - 超大尺寸
      ctx.font = '50px Apple Color Emoji, Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillStyle = item.iconColor
      ctx.fillText(item.icon, centerX, centerY - 50)

      // 绘制数值 - 超大突出
      ctx.fillStyle = item.iconColor
      ctx.font = 'bold 58px PingFang SC, Microsoft YaHei, Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText(item.value, centerX, centerY + 10)

      // 绘制标签 - 清晰大字
      ctx.fillStyle = '#666'
      ctx.font = '28px PingFang SC, Microsoft YaHei, Arial'
      ctx.fillText(item.label, centerX, centerY + 60)
    },

    /**
     * 绘制多行文本
     */
    drawMultilineText (ctx, text, x, y, maxWidth, lineHeight) {
      const words = text.split('')
      let line = ''
      let currentY = y

      for (let i = 0; i < words.length; i++) {
        const testLine = line + words[i]
        const metrics = ctx.measureText(testLine)
        if (metrics.width > maxWidth && i > 0) {
          ctx.fillText(line, x, currentY)
          line = words[i]
          currentY += lineHeight
        } else {
          line = testLine
        }
      }
      ctx.fillText(line, x, currentY)
    },

    async generateShareImage (record) {
      this.isGeneratingImage = true

      return new Promise((resolve) => {
        // 创建背景图片
        const backgroundImg = new Image()
        backgroundImg.crossOrigin = 'anonymous'
        backgroundImg.onload = () => {
          try {
            // 创建画布，尺寸为1080*1440
            const canvas = document.createElement('canvas')
            canvas.width = 1080
            canvas.height = 1440
            const ctx = canvas.getContext('2d')

            // 绘制背景图片
            ctx.drawImage(backgroundImg, 0, 0, canvas.width, canvas.height)

            // 内容区域：起点(90,356) 终点(982,912)
            const contentArea = {
              x: 90,
              y: 356,
              width: 982 - 90, // 892px
              height: 912 - 356 // 556px
            }

            // 在内容区域绘制训练数据
            this.drawTrainingDataOnBackground(ctx, record, contentArea)

            this.isGeneratingImage = false
            resolve(canvas.toDataURL('image/png'))
          } catch (error) {
            console.error('生成分享图片失败:', error)
            this.isGeneratingImage = false
            resolve(null)
          }
        }

        backgroundImg.onerror = () => {
          console.error('背景图片加载失败')
          this.isGeneratingImage = false
          resolve(null)
        }

        // 设置背景图片URL
        backgroundImg.src = 'https://cdn.keihong.tech/img/bg-daka-v1.png'
      })
    },
    closeSharePreview () {
      this.showSharePreview = false
      this.shareImageUrl = null
    },
    saveShareImage () {
      this.saveImageToAlbum(this.shareImageUrl).then(() => {
        this.$toast.success('分享图片已保存到相册')
        this.closeSharePreview()
      }).catch(err => {
        this.$toast.fail('保存失败，请重试')
        console.error('保存失败:', err)
      })
    },
    startLongPress () {
      this.isLongPressing = true
      this.longPressTimer = setTimeout(() => {
        // 触发震动反馈（如果设备支持）
        if (navigator.vibrate) {
          navigator.vibrate(100)
        }
        this.saveShareImage()
      }, 1000) // 1秒长按时间
    },
    endLongPress () {
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer)
        this.longPressTimer = null
      }
      this.isLongPressing = false
    }
  },
  watch: {},
  computed: {}
}
</script>
<style scoped>
.bg {
  background: linear-gradient(180deg, #D3FFEC 0%, #94FFD0 29%, #FFFFFF 100%);
}

.daily-status .van-grid-item {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
}

.container {
  display: flex; /* 使用 flex 布局 */
  flex-wrap: wrap; /* 允许内容换行 */
  width: 100%; /* 容器占满整个父元素宽度 */
}

.square {
  width: 14.285%; /* 每个 square 占行宽的 1/7 */
  padding-bottom: 14.285%; /* 使用 padding-bottom 设置高度相等于宽度，确保正方形 */
  position: relative; /* 相对定位 */
}

.content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white; /* 设置内容的文字颜色 */
  margin: 2px;
  border-radius: 50%;

}

.item-text {
  text-align: center;
  font-size: 12px;
}

.custom-upload-icon img {
  width: 100%; /* 根据需要调整宽度 */
  height: auto; /* 保持图片比例 */
}

.play-video {
  width: 100%;
  height: calc(100vw * 9 / 16);
}

/* 本周打卡作业卡片样式 */
.weekly-tasks-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  margin: 16px;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 8px 24px rgba(18, 185, 106, 0.12);
  border: 1px solid rgba(18, 185, 106, 0.08);
  position: relative;
  overflow: hidden;
}

.weekly-tasks-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #12B96A 0%, #94FFD0 100%);
}

.tasks-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.tasks-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #12B96A 0%, #94FFD0 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  box-shadow: 0 4px 12px rgba(18, 185, 106, 0.2);
}

.tasks-icon .van-icon {
  color: white !important;
}

.tasks-title {
  flex: 1;
}

.main-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
}

.sub-title {
  font-size: 14px;
  color: #12B96A;
  font-weight: 500;
}

.tasks-content {
  margin-bottom: 20px;
}

.task-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.task-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  border: 1px solid rgba(18, 185, 106, 0.1);
  transition: all 0.3s ease;
}

.task-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(18, 185, 106, 0.15);
}

.task-number {
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #12B96A 0%, #94FFD0 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  font-weight: 600;
  margin-right: 12px;
  flex-shrink: 0;
}

.task-text {
  flex: 1;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.task-status {
  margin-left: 8px;
}

.tasks-footer {
  text-align: center;
  padding-top: 16px;
  border-top: 1px solid rgba(18, 185, 106, 0.1);
}

/* 响应式设计 */
@media (max-width: 375px) {
  .weekly-tasks-card {
    margin: 12px;
    padding: 16px;
  }

  .tasks-icon {
    width: 40px;
    height: 40px;
    margin-right: 12px;
  }

  .main-title {
    font-size: 16px;
  }

  .task-item {
    padding: 10px 12px;
  }
}
.game-record-card {
  background: linear-gradient(135deg, #e0f7fa 0%, #f8fffe 100%);
  border-radius: 18px;
  box-shadow: 0 4px 18px rgba(18, 185, 106, 0.10), 0 1.5px 4px rgba(0,0,0,0.04);
  margin: 0 12px 20px 12px;
  padding: 20px 16px 16px 16px;
  position: relative;
  transition: transform 0.2s, box-shadow 0.2s;
  border: 1.5px solid #b2ebf2;
}
.game-record-card:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 32px rgba(18, 185, 106, 0.18);
}
.game-record-card__date {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #12B96A;
  margin-bottom: 12px;
  letter-spacing: 1px;
}
.game-record-card__main {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  margin-bottom: 12px;
  gap: 8px;
}
.game-record-card__item {
  flex: 1;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(18, 185, 106, 0.04);
  padding: 10px 4px 8px 4px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.game-record-card__num {
  font-size: 22px;
  font-weight: bold;
  color: #222;
  margin: 4px 0 2px 0;
}
.game-record-card__label {
  font-size: 12px;
  color: #888;
}
.game-record-card__stars {
  text-align: center;
  margin: 8px 0 2px 0;
}
.game-record-card__rating-text {
  text-align: center;
  color: #12B96A;
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 2px;
}
.game-record-card__encourage {
  text-align: center;
  color: #888;
  font-size: 13px;
  margin-bottom: 2px;
}
.game-record-card__share {
  text-align: center;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid rgba(18, 185, 106, 0.1);
}

.game-record-card__share .van-button {
  min-width: 120px;
  height: 36px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(18, 185, 106, 0.2);
  transition: all 0.3s ease;
}

.game-record-card__share .van-button:active {
  transform: translateY(1px);
  box-shadow: 0 1px 4px rgba(18, 185, 106, 0.3);
}

/* 分享预览弹窗样式 */
.share-preview-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
}

.share-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px 24px;
  border-bottom: 1px solid #f5f5f5;
  background: #fff;
}

.share-preview-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.share-preview-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: #f8f9fa;
  overflow: hidden;
}

.share-preview-loading {
  text-align: center;
}

.loading-text {
  margin-top: 16px;
  font-size: 16px;
  color: #666;
}

.share-preview-image {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.share-preview-image img {
  max-width: 100%;
  max-height: 80%;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  cursor: pointer;
}

.share-preview-image img:active {
  transform: scale(0.98);
  box-shadow: 0 4px 12px rgba(18, 185, 106, 0.3);
}

.share-preview-image.long-pressing img {
  transform: scale(0.95);
  box-shadow: 0 2px 8px rgba(18, 185, 106, 0.3);
}

.long-press-progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  z-index: 10;
}

.progress-circle {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.progress-text {
  font-size: 14px;
  color: #12B96A;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.95);
  padding: 6px 12px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.share-preview-tip {
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: rgba(18, 185, 106, 0.1);
  border-radius: 20px;
  font-size: 14px;
  color: #12B96A;
}

.share-preview-actions {
  padding: 20px 24px;
  display: flex;
  gap: 12px;
  background: #fff;
  border-top: 1px solid #f5f5f5;
}

.share-preview-actions .van-button {
  flex: 1;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 375px) {
  .game-record-card {
    padding: 14px 6px 10px 6px;
  }
  .game-record-card__main {
    gap: 4px;
  }
  .game-record-card__num {
    font-size: 18px;
  }

  .share-preview-header {
    padding: 16px 20px 12px 20px;
  }

  .share-preview-content {
    padding: 16px;
  }

  .share-preview-actions {
    padding: 16px 20px;
  }

  .share-preview-actions .van-button {
    height: 40px;
    font-size: 14px;
  }
}
</style>
